import { useState } from 'react'
import { useIsMobile } from '@/hooks/use-media-query'
import { StampIcon } from './stamp-icon'

const NAV_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'Pricing', href: '#pricing' },
  // { label: 'For Builders', href: '/for-builders' },
  // { label: 'Docs', href: '#' },
  // { label: 'GitHub', href: '#' },
]

export function Navbar() {
  const mobile = useIsMobile()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(253,248,243,0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(237,233,228,0.6)',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: mobile ? '16px 20px' : '16px 48px',
          maxWidth: 1300,
          margin: '0 auto',
        }}
      >
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'inherit' }}>
          <StampIcon size={36} variant="cream" />
          <span style={{ fontWeight: 800, fontSize: 20, letterSpacing: '-0.02em' }}>
            one-email
          </span>
        </a>

        {/* Desktop links */}
        <div style={{ display: mobile ? 'none' : 'flex', alignItems: 'center', gap: 32 }}>
          {NAV_LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              style={{
                color: item.label === 'For Builders' ? '#FF6B00' : '#6d6462',
                textDecoration: 'none', fontSize: 15, fontWeight: 600,
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => { (e.target as HTMLElement).style.color = '#1a1216' }}
              onMouseLeave={(e) => { (e.target as HTMLElement).style.color = item.label === 'For Builders' ? '#FF6B00' : '#6d6462' }}
            >
              {item.label}
            </a>
          ))}
          <span
            style={{
              background: '#1a1216', color: '#FDF8F3', padding: '11px 26px',
              borderRadius: 12, fontSize: 14, fontWeight: 700,
              opacity: 0.5, cursor: 'default',
            }}
          >
            Coming soon
          </span>
        </div>

        {/* Mobile hamburger button */}
        {mobile && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: 8, display: 'flex', flexDirection: 'column', gap: 5,
            }}
            aria-label="Toggle menu"
          >
            <span style={{
              display: 'block', width: 24, height: 2, background: '#1a1216', borderRadius: 2,
              transition: 'transform 0.2s, opacity 0.2s',
              transform: menuOpen ? 'rotate(45deg) translateY(7px)' : 'none',
            }} />
            <span style={{
              display: 'block', width: 24, height: 2, background: '#1a1216', borderRadius: 2,
              transition: 'opacity 0.2s',
              opacity: menuOpen ? 0 : 1,
            }} />
            <span style={{
              display: 'block', width: 24, height: 2, background: '#1a1216', borderRadius: 2,
              transition: 'transform 0.2s, opacity 0.2s',
              transform: menuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none',
            }} />
          </button>
        )}
      </div>

      {/* Mobile dropdown menu */}
      {mobile && menuOpen && (
        <div
          style={{
            padding: '8px 20px 20px',
            display: 'flex', flexDirection: 'column', gap: 4,
            borderTop: '1px solid rgba(237,233,228,0.6)',
            background: 'rgba(253,248,243,0.95)',
          }}
        >
          {NAV_LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              style={{
                color: item.label === 'For Builders' ? '#FF6B00' : '#6d6462',
                textDecoration: 'none', fontSize: 16, fontWeight: 600,
                padding: '12px 0',
                borderBottom: '1px solid rgba(237,233,228,0.4)',
              }}
            >
              {item.label}
            </a>
          ))}
          <span
            style={{
              background: '#1a1216', color: '#FDF8F3', padding: '14px 26px',
              borderRadius: 12, fontSize: 15, fontWeight: 700,
              textAlign: 'center', marginTop: 8,
              opacity: 0.5, cursor: 'default',
              display: 'block',
            }}
          >
            Coming soon
          </span>
        </div>
      )}
    </nav>
  )
}
